// @components
import { Collapse } from 'antd';
import { useContext } from 'react';
import Context from 'context/appContext';
import Check from '../../../assets/images/check-circle.svg'

//@utils
import { formatPrice } from 'utils/utils';

// collapsable de las coberturas por planes
export default function CollapseComponent() {
    const { sidebarData, isActiveAditionals } = useContext(Context);

    return (
        <Collapse className='ant-collapse-generic' >
            {sidebarData && sidebarData.map((data) =>
                <><h2>{data.title ? data.title : ''}</h2>
                    {data && data.items.map((item, index) =>
                        <Collapse.Panel header={<div className='ant-collapse-header-description'>
                            <span>{item.title ? item.title : ''}</span>
                            <p>{item.price ? formatPrice(item.price) : ''}</p></div>} key={index}>
                            <ul className='list-plans'>
                                {item && item.values.map((value) => <>
                                    <li>
                                        <strong>{value.title ? value.title : ''}</strong>
                                    </li>
                                    {value.rows.map(row =>
                                        row.label && row.value && (<li>
                                            <p title={row.label.length > 19 && row.label}>{row.label}</p>
                                            <p>{row.value === '$ 0' ? <img src={Check} alt='Imagen check' /> : row.value}</p>
                                        </li>))}
                                    {item && item.title === 'Opcionales Seleccionadas' && <li>
                                        <p title='TERREMOTO Y ERUPCIÓN VOLCÁNICA'>TERREMOTO Y ERUPCIÓN VOLCÁNICA </p>
                                        <div>
                                            {isActiveAditionals['TEV'] && <img src={Check} alt='Imagen check' />}
                                        </div>
                                        <p title='FENÓMENOS HIDROMETEOROLÓGICOS'>FENÓMENOS HIDROMETEOROLÓGICOS</p>
                                        <div>
                                            {isActiveAditionals['FHM'] && <img src={Check} alt='Imagen check' />}
                                        </div>
                                    </li>}
                                    {item && item.title === 'Asistencias Básicas Incluídas' && <li>
                                        <p>PLOMERÍA</p>
                                        <div>
                                            {<img src={Check} alt='Imagen check' />}
                                        </div>
                                        <p>ELECTRICIDAD</p>
                                        <div>
                                            {<img src={Check} alt='Imagen check' />}
                                        </div>
                                        <p>CERRAJERÍA</p>
                                        <div>
                                            {<img src={Check} alt='Imagen check' />}
                                        </div>
                                        <p>ALBAÑILERÍA</p>
                                        <div>
                                            {<img src={Check} alt='Imagen check' />}
                                        </div>
                                        <p>CARPINTERÍA</p>
                                        <div>
                                            {<img src={Check} alt='Imagen check' />}
                                        </div>
                                        <p>SERVICIOS DE SEGURIDAD</p>
                                        <div>
                                            {<img src={Check} alt='Imagen check' />}
                                        </div>
                                    </li>}
                                </>)}
                            </ul>
                        </Collapse.Panel>)}</>
            )}
        </Collapse >
    )
}